import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, DatePicker } from 'components';
import { Globals, checkPermission, Constants, Print } from 'utils';
import { PlanningService } from 'services';
import moment from 'moment';
import { CleanIcon, EditIcon, PrintIcon } from 'assets/icons';
import ModalRoutes from './modal-routes';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	status: '',
	route_id: ''
}

declare var window: any;

class Planning extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'#Orden',
			'Cliente',
			'Talento',
			'Municipio',
			'Tipo Servicio',
			'Precio',
			'Ruta',
			'Acciones'
		],
		loading: true,
		visible: false,
		item: null,
		routes: [],
		date: ''
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Planificación',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await PlanningService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			date: this.state.date && moment(this.state.date).format('YYYY-MM-DD')
		});
		this.setState({
			loading: false,
			data: res.quotes.rows,
			last_page: res.quotes.count,
			routes: res.routes || []
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	loadDate = () => {
		if (!this.state.date) {
			Globals.showError("Por favor, indique una fecha");
			return;
		}

		this.load();
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => this.load());
	}

	assign = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	print = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await PlanningService.admin.download({
			quote_id: item.id
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="admin-planning">
				<BackComponent />

				<Modal
		          className="modal-select-routes"
		          visible={ visible }
		          title="Asignar rutas"
		          centered
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalRoutes
		          	item={ this.state.item }
		          	onClose={ () => this.onClose() }
		          />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12 row">
						<div className="col-md-3">
							<DatePicker
								placeholder="Fecha"
								onChange={ (text: string) => {
									this.setState({
										form: INITIAL_STATE,
										page: 1,
										date: text
									});
								} }
								value={ this.state.date }
							/>
						</div>
						<div className="col-md-3">
							<button className="btn btn-add" onClick={ () => this.loadDate() }>
								Cargar
							</button>
						</div>
					</div>
				</div>

				{
					this.state.date != '' && !this.state.loading && (
						<div className="row row-filter">
							<div className="col-md-3">
								<Select
									placeholder="Ruta"
									name="route_id"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.route_id }
									options={ this.state.routes.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Estatus"
									name="status"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.PLANNING_STATUS.PENDING.toString(), label: 'Pendientes por asignar' },
										{ value: Constants.PLANNING_STATUS.ASSIGN.toString(), label: 'Asignadas' },
									] } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					)
				}

				{
					this.state.date != '' && !this.state.loading && (
						<>
							<Table data={ this.state.data.length } header={ this.state.header }>
								{ this.state.data.map((i: any,index: number) => {
									return (
										<tr key={ index }>
											<td>{ i.number }</td>
											<td>{ i.user?.full_name || '-' }</td>
											<td>{ i.operators?.length > 0 ? i.operators?.map((i: any) => i.operator?.full_name).join(', ') : '-' }</td>
											<td>{ i.municipality?.name || '-' }</td>
											<td>{ i.service?.type_id == Constants.SERVICE_TYPES.CLEAN ? i.type?.name : '-' }</td>
											<td>{ Globals.formatMiles(i.price) }</td>
											<td>{ i.route?.name || '-' }</td>
											<td>
												{
													checkPermission(Constants.MODULES.PLANNING,'write') && (
														<Tooltip title="Editar">
															<a className="link-icon" href="#" onClick={ (e: any) => this.assign(e,i) }>
																<img src={ EditIcon } />
															</a>
														</Tooltip>
													)
												}
												<Tooltip title="Imprimir">
													<a className="link-icon" href="#" onClick={ (e: any) => this.print(e,i) }>
														<img src={ PrintIcon } />
													</a>
												</Tooltip>
											</td>
										</tr>
									)
								}) }
							</Table>

							<Pagination 
								pages={ this.state.last_page } 
								active={ this.state.page }
								onChange={ async (page: number) => {
									await this.setState({
										page: page
									});
									this.load();
								} } />
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Planning);